import {
  GET_COMPANIES_SUCCESS,
  GET_COMPANY_SUCCESS,
  SET_COMPANY_SUCCESS,
  PUT_COMPANY_SUCCESS,
  COMPANIES_CLEAN,
  SET_MESSAGE_MODAL_FAILURE,
  MESSAGE_MODAL_CLEAN,
} from "../constants/actionTypes";
const INITIAL_STATE = {
  list: [],
  data: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_COMPANIES_SUCCESS:
      return {
        ...state,
        list: action.payload.Retorno,
      };
    case GET_COMPANY_SUCCESS:
      return {
        ...state,
        data: action.payload.Retorno,
      };
    case SET_COMPANY_SUCCESS:
      return {
        ...state,
        data: action.payload.Retorno,
        status: action.payload?.StatusCode,
      };
    case PUT_COMPANY_SUCCESS:
      return {
        ...state,
        data: action.payload.Retorno,
        status: action.payload?.StatusCode,
      };
    case COMPANIES_CLEAN:
      return {
        ...state,
        status: null,
      };
    case SET_MESSAGE_MODAL_FAILURE:
      return {
        ...state,
        data: action.payload.Retorno,
        status: action.payload?.StatusCode,
      };
    case MESSAGE_MODAL_CLEAN:
      return {
        ...state,
        data: null,
        status: null,
      };
    default:
      return state;
  }
};
